import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  Divider,
  DialogTitle,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { addCategory, getCategory } from "./expanceApi";
import { ModalHeader } from "../../common/modalHeader";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "40%",
  transform: "translate(-50%, -50%)",
  border: "none",
  bgcolor: "background.paper",
};

export const CategoryPop = ({
  open,
  setOpen,
  setSelectedCategory,
  selectedCategory,
  callback,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  
  return (
    <Modal
      open={open}
      onClose={() => {
        setSelectedCategory({ name: "" });
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Box
          sx={{
            ...style,
            width: {
              xs: "90%",
              sm: "30%",
            },
            background: "1",
            borderRadius: "5px",
          }}
        >
          {/* <ModalHeader
            title={"Expense Category "}
            onClose={(data) => {
              setOpen(data);
            }}
          /> */}

          <DialogTitle
            color="primary"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "auto",
              color: "#000000",
              backgroundColor: "#CECEFF",
              // padding: "10px 20px 10px 30px",
              // padding: "16px 24px",
              fontFamily: "'Montserrat', sans-serif",
              // borderRadius: "10px",
              fontSize: { xs: "12px", sm: "16px", md: "20px" },
              boxShadow: "0px 4px 4px #01008B4F;",
            }}
          >
            Expense Category
            <CloseIcon
              sx={{ float: "left", cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
          </DialogTitle>
          <Box
            sx={{
              padding: "25px",
            }}
          >
            <TextField
              fullWidth
              id="BrifeAddress"
              label="Expenses Category"
              size="small"
              name="BrifeAddress"
              value={selectedCategory?.name}
              InputLabelProps={{
                className: "mulish",
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
              InputProps={{
                style: {
                  // height: '40px',
                  // background:"yellow"
                },
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
              onChange={(e) => {
                setSelectedCategory({
                  ...selectedCategory,
                  name: e.target.value,
                });
              }}
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: { xs: "12px", sm: "16px", md: "20px" },
                },
              }}
            />

            <Divider sx={{ bgcolor: "primary.main", marginTop: "10px" }} />

            <Box sx={{ paddingX: "20px" }}>
              <Button
                variant="contained"
                sx={{
                  width: "100%",
                  mt: "10px",
                  fontSize: { xs: "12px", sm: "16px", md: "20px" },
                }}
                onClick={() => {
                  callback(selectedCategory);
                  setSelectedCategory({ name: "" });
                  setOpen(false);
                }}
              >
                {isEdit ? "Update" : "Add"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
